import { useQuery } from "@apollo/client";
import { GET_COMPANY_DOCUMENT_FOLDER_BY_ID } from "../api/get-company-document-folder-by-id";
import { useEditMode } from "@/shared/form/form";
import { extractLocalizedValue } from "@/shared/form/localized-value/utils/extract-localized-value";
import { FolderFieldsType } from "./types";

export function useCompanyDocumentFolderEntity({
  id,
  parentId,
}: {
  id?: string;
  parentId?: string | null;
}) {
  const { formKey, onEntityLoaded } = useEditMode();
  const { data, loading } = useQuery(GET_COMPANY_DOCUMENT_FOLDER_BY_ID, {
    variables: { id: id as string },
    skip: !id,
    onCompleted: onEntityLoaded,
  });

  const folder = data?.getCompanyDocumentFolderById;

  const entity: Partial<FolderFieldsType> = folder
    ? {
        id: folder.id,
        parentId: folder.parentId,
        color: folder.color,
        name: extractLocalizedValue(folder.name),
        structureIds: [
          ...(folder.access?.organizations.map((item) => item.id) ?? []),
          ...(folder.access?.positions.map((item) => item.id) ?? []),
        ],
        jobIds: folder.access?.jobs.map((item) => item.id) ?? [],
      }
    : {
        parentId: parentId ?? null,
      };

  return { entity, loading, formKey };
}
